import { getSettings, loadRecoveryScript } from "./settings";
import { getDismissData, getRenderData, hasRecovered } from "./softwall/data";
import {
  onDismiss as onDismissHandler,
  onPageView,
  onPremiumUserDetected,
  onRecover,
} from "./softwall/handlers";
import { DismissData } from "./softwall/types";
import {
  adsAllowed,
  detectAdBlocker,
  detectPremiumABUser,
  getAADetectionResult,
  renderAllowed,
} from "./softwall/utils";

(async () => {
  if (window.__bt_rlink_already_invoked) return;
  // a safety check to avoid running rlink script running twice
  // it could happen was injected into the page along with bt_tag in inject from tag mode
  // or a bug with an infinite script loading cycle

  window.__bt_rlink_already_invoked = true;

  const settings = await getSettings();
  const { allow_render_to_aa_users, hard_message_wall_mode_enabled } = settings;
  const [aaDetectionResults, detectedExtension, hasRendered, isPremiumAbUser] =
    await Promise.all([
      getAADetectionResult(),
      detectAdBlocker(),
      getRenderData(),
      detectPremiumABUser(),
    ]);

  // detectedExtension going to contain "abp" by default even if there no any adblocker enabled.
  onPageView(aaDetectionResults, detectedExtension);

  // RL should not be rendered if ads already allowed (AB disabled or AA enabled and rendering not allowed for AA users)
  const shouldNotBeRendered = adsAllowed(
    aaDetectionResults,
    allow_render_to_aa_users
  );

  // Stop RL for first run if it should not be rendered
  if (!hasRendered && shouldNotBeRendered) {
    return;
  }

  const swRecovered = hasRecovered(settings, aaDetectionResults);

  // recovery event
  if (swRecovered) {
    onRecover(swRecovered, detectedExtension);
    return;
  }

  const onDismiss = (dismissData: DismissData) => {
    loadRecoveryScript(settings, aaDetectionResults.acceptable);
    onDismissHandler(dismissData, detectedExtension);
  };

  // dismiss event
  const dismissData = getDismissData();
  if (dismissData && !hard_message_wall_mode_enabled) {
    onDismiss(dismissData);
    return;
  }

  // handle premium ABP users
  if (isPremiumAbUser) {
    onPremiumUserDetected(detectedExtension);
    return;
  }

  // render RL if the rules for rendering are met
  if (!shouldNotBeRendered && (await renderAllowed(settings))) {
    import("./App").then(({ render }) => {
      render(detectedExtension, settings, onDismiss);
    });
  } else {
    loadRecoveryScript(settings, aaDetectionResults.acceptable);
  }
})();
